
define('text!templates/components/product_category/product_category.html',[],function () { return '<td data-cell="name">\n    <a href="/product-categories/<%= id %>"><%= name %></a>\n</td>\n\n<td data-cell="code">\n    <%= code %>\n</td>\n';});

